import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, signal, ViewChild } from '@angular/core';
import SignaturePad from 'signature_pad';
import trimCanvas from 'trim-canvas';

@Component({
  selector: 'lfe-signature-canvas',
  imports: [],
  standalone: true,
  templateUrl: './signature-canvas.component.html',
  styleUrl: './signature-canvas.component.css'
})
export class SignatureCanvasComponent implements OnInit, OnDestroy {
  @ViewChild('signatureCanvas', { static: true }) signatureCanvas!: ElementRef<HTMLCanvasElement>;

  @Output() hasDrawnChange = new EventEmitter<boolean>();

  signaturePad = signal<SignaturePad | null>(null);
  private beginStrokeHandler?: () => void;

  ngOnInit(): void {
    const canvasEl = this.signatureCanvas.nativeElement;
    const signaturePad = new SignaturePad(canvasEl, {
      throttle: 16
    });
    this.signaturePad.set(signaturePad);

    this.beginStrokeHandler = () => {
      this.hasDrawnChange.emit(true);
    };
    signaturePad.addEventListener('beginStroke', this.beginStrokeHandler);
  }

  ngOnDestroy(): void {
    const pad = this.signaturePad();
    if (pad && this.beginStrokeHandler) {
      pad.removeEventListener('beginStroke', this.beginStrokeHandler);
      pad.off();
    }
  }

  getTrimmedCanvas = () => {
    const copy = document.createElement('canvas');
    const canvasEl = this.signatureCanvas.nativeElement;
    copy.width = canvasEl.width;
    copy.height = canvasEl.height;
    copy.getContext('2d', { willReadFrequently: true })?.drawImage(canvasEl, 0, 0);
    return trimCanvas(copy);
  };

  getDataURL(): string {
    return this.getTrimmedCanvas().toDataURL() || '';
  }

  getBase64(): string {
    const dataURL = this.getDataURL();
    return dataURL.replace('data:image/png;base64,', '');
  }
}
